import { createLoadingStore } from '@frontend-shared/loading'

export const loadingStore = createLoadingStore()
